import React from "react";

import dayjs from "dayjs";
import { DoneCheck, Close } from "icons";

import { Tag } from "clearsense-ui/components";
import { Steward } from "components/Common/TableStyle";

const getStatusColor = text => {
  switch (text) {
    case "Ingested":
      return "#EBF4EC";
    case "Profiled":
      return "#FDF0E3";
    case "Scanned":
      return "#FAEAEA";
    default:
      return "";
  }
};

const getStatusIcon = text => (text === "Failed" ? Close : DoneCheck);

export const DATA_SOURCE_COLUMNS = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: 200,
    fixed: "left",
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: 300,
  },
  {
    title: "Type",
    key: "type",
    dataIndex: "type",
    width: 200,
    render: () => "RDBMS",
  },
  {
    title: "Data Source Status",
    key: "status",
    dataIndex: "status",
    width: 200,
    render: text =>
      text ? (
        <Tag
          label={text}
          color={getStatusColor(text)}
          icon={getStatusIcon(text)}
          className="flex-row-reverse "
        />
      ) : (
        <Tag
          label="Ingested"
          color={getStatusColor("Ingested")}
          icon={getStatusIcon("Ingested")}
          className="flex-row-reverse "
        />
      ),
  },
  {
    title: "# Data source data elements",
    key: "dsdes_count",
    dataIndex: "dsdes_count",
    width: 150,
  },
  {
    title: "# Incomplete data source data elements",
    key: "unmapped_count",
    dataIndex: "unmapped_count",
    width: 200,
  },
  {
    title: "Drafter",
    key: "drafter",
    dataIndex: "drafter",
    width: 200,
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Approver",
    key: "approver",
    dataIndex: "approver",
    width: 200,
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Last Updated",
    key: "updated_at",
    dataIndex: "updated_at",
    width: 200,
    render: text => dayjs(text).format("MM/DD/YYYY"),
  },
];
